import React, { useEffect, useState } from 'react';
import AdminTable from 'common/AdminTable';
import DateFilter from 'common/DateFilter';
import { Link } from 'react-router-dom';
import { toast } from 'react-toastify';

const API_URL = process.env.REACT_APP_BACKEND_URL || process.env.REACT_APP_BACKEND;

const getToken = () => localStorage.getItem('token');

const UsersList = () => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [filteredUsers, setFilteredUsers] = useState([]);

  const fetchUsers = async () => {
    setLoading(true);
    try {
      const res = await fetch(`${API_URL}users`, {
        headers: { Authorization: `Bearer ${getToken()}` },
      });
      if (res.ok) {
        const result = await res.json();
        setData(Array.isArray(result) ? result : []);
      } else {
        toast.error('Failed to fetch users');
      }
    } catch {
      toast.error('Connection failed');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchUsers();
  }, []);

  const handleDelete = async (id) => {
    if (!window.confirm('Are you sure?')) return;
    try {
      const res = await fetch(`${API_URL}users/${id}`, {
        method: 'DELETE',
        headers: { Authorization: `Bearer ${getToken()}` },
      });
      if (res.ok) {
        toast.success('User deleted');
        fetchUsers();
      } else {
        toast.error('Failed to delete');
      }
    } catch {
      toast.error('Connection failed');
    }
  };

  const filterColumns = [
    { Header: 'ID', accessor: 'id' },
    { Header: 'Name', accessor: 'name' },
    { Header: 'Email', accessor: 'email' },
    { Header: 'Mobile', accessor: 'mobile' },
    { Header: 'Address', accessor: 'address' },
  ];

  const tableHeaders = [
    { Header: 'ID', accessor: 'id' },
    { Header: 'Name', accessor: 'name' },
    { Header: 'Email', accessor: 'email' },
    { Header: 'Mobile', accessor: 'mobile' },
    { Header: 'Address', accessor: 'address' },
    {
      Header: 'Actions',
      accessor: 'actions',
      Cell: ({ row }) => (
        <>
          <Link className="btn btn-success btn-sm mx-1" to={`/users/update/${row.original.id}`}>
            Edit
          </Link>
          <button className="btn btn-danger btn-sm mx-1" onClick={() => handleDelete(row.original.id)}>
            Remove
          </button>
        </>
      ),
    },
  ];

  return (
    <div className="container-fluid mt-5">
      <div className="mainheadig mx-4">
        <h4 className="text-white font-weight-bold">Users List</h4>
      </div>

      {loading ? (
        <p className="text-white mx-4">Loading...</p>
      ) : data.length > 0 ? (
        <>
          <div className="mx-4">
            <DateFilter
              data={data}
              dateField="createdAt"
              title="Users Report"
              columns={filterColumns}
              onFilteredData={setFilteredUsers}
            />
          </div>
          <AdminTable tableHeaders={tableHeaders} tableData={filteredUsers} />
        </>
      ) : (
        <p className="text-white mx-4">No users found.</p>
      )}
    </div>
  );
};

export default UsersList;